export const toggleScrollLock = (shouldLock: boolean) => {
  const html = document.querySelector('html')!
  const lockCss = shouldLock ? 'hidden' : ''
  html.style.overflow = lockCss
}
